import { z } from "zod";

export const moduleSchema = () => {
  return z.object({
    agreement: z.string().optional(),
    predefined: z.number().optional(),
    section_title: z.string().min(1),
    title: z.string().min(1),
    icon: z.string().min(1),
    url: z.string().min(1),
    is_external: z.boolean(),
    allow_edit: z.boolean(),
    active: z.boolean()
  });
};

export type ModuleFormValues = z.infer<ReturnType<typeof moduleSchema>>;
